export default __webpack_public_path__ + "static/media/1.1.0.16c147cd.yaml";